import { daysBetween } from '../../dates/models/DateFunctions';
import { CalendarEvent } from '../models/calendar-event';

export class DayIndexUtil {
    /**
     * Builds an array and groups events into each "slot" defined by `indexGetter`.  
     * @example
     * ['events on monday', 'events on tuesday', 'events on wednesday', '...']
     * @param indexGetter A function that must return a unique index, eg: `date.getDay()`.
     */
    static buildIndex(startDate: Date, endDate: Date, events: CalendarEvent[], indexGetter: (date: Date) => number): Array<CalendarEvent[]> {
        //Build event index
        let eventIndex = new Array(daysBetween(startDate, endDate));

        events?.forEach((event: CalendarEvent) => {
            if (!event)
                return;

            if (event.startDate < startDate || event.endDate > endDate)
                return;

            const day = indexGetter(event.startDate);

            const events = eventIndex[day];

            if (events)
                events.push(event);
            else
                eventIndex[day] = [event];
        })

        return eventIndex;
    }
}